<template>
  <div>
    <v-container grid-list-xl fluid>
      <table-payout-address coin="XRP"></table-payout-address>
    </v-container>
  </div>
</template>

<script>
import TablePayoutAddress from "@/components/table/TablePayoutAddress";

export default {
  name: "RippleList",
  components: {
    TablePayoutAddress
  }
};
</script>

<style scoped></style>
